import {
    Company,
    Contact,
    MonthlyReportData,
    PaymentIntentCreateParams,
    Policy,
    PolicyBillingSettings,
    PolicyLayer,
    Property,
} from "@deathstar/types/northstar";
import { BillingInformation, PayBillFormData } from "@deathstar/types/waypoint";
import React from "react";
import Stripe from "stripe";

export interface IContext {
    company?: Company;
    properties?: Property[];
    amsClientNumber?: number;
    waypointVersion?: boolean;

    enableActions:
        | boolean
        | { payNow: boolean; reportNow: boolean; viewStatement: boolean; viewBillingPeriodDetails: boolean; billingSettings: boolean };
    billingInfo?: BillingInformation;
    contacts?: Contact[];
    isLoadingBillingInfo?: boolean;
    createPayment?(options: PaymentIntentCreateParams | PayBillFormData): Promise<Pick<Stripe.PaymentIntent, "id">>;
    navigateToReporting?: (options: { policyId: string; year?: number; month?: number; report?: Policy.IReport | null }) => void;
    currentMonthReports?: Record<string, MonthlyReportData | null>;
    getPolicyLayerMetadata?: (policy: Policy) => Promise<PolicyLayer.Metadata[]>;
    onPaymentSuccess(options: { policyId: string }): Promise<void>;
    updateBillingSettings?: (options: { policyId: string }, settings: PolicyBillingSettings) => Promise<PolicyBillingSettings | void>;
}

export const Context = React.createContext<IContext>({
    waypointVersion: false,
    enableActions: false,
    billingInfo: undefined,
    contacts: [],
    isLoadingBillingInfo: false,
    createPayment: undefined,
    company: undefined,
    properties: [],
    amsClientNumber: undefined,
    navigateToReporting: undefined,
    currentMonthReports: undefined,
    getPolicyLayerMetadata: () => Promise.resolve([]),
    onPaymentSuccess: () => Promise.resolve(),
    updateBillingSettings: () => Promise.resolve(),
});
